import React, { useState, useEffect, useCallback } from "react";
import style from "./VendorCountCard.module.css";
import CustomSwitch from "../Switch/CustomSwitch";
import CustomSelect from "../Select/CustomSelect";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { stateShortFormObj } from "../../Utils/helper";

const locationDropdownStyle = {
  backgroundColor: "white",
  mb: "0.5rem",
};

function VendorLocationCard({
  vendorId = 0,
  isReassign = false,
  reassignType = "",
  dropdownData = [],
  isLocationSelectOpen = false,
  dataToSend = null,
  setDataToSend = () => {},
  locationDropClickHandler = () => {},
}) {
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [specialisedSwitch, setSpecialisedSwitch] = useState(0);

  const setActionsOnDataToSend = useCallback(
    (state, city, isSpecialised) => {
      setDataToSend((prevData) => {
        let newData = [...prevData];
        newData[vendorId - 1] = {
          ...newData[vendorId - 1],
          state,
          city,
          isSpecialised,
        };
        return newData;
      });
      if (dataToSend?.[vendorId - 1]) {
      }
    },
    [vendorId]
  );

  const stateChangeHandler = (e) => {
    setSelectedState(e.target.outerText || "");
    setSelectedCity("");
    setActionsOnDataToSend(e.target.outerText, "", specialisedSwitch);
  };
  const selectCityHandler = (e) => {
    setSelectedCity(e.target.outerText || "");
    setActionsOnDataToSend(
      selectedState,
      e.target.outerText,
      specialisedSwitch
    );
    if (e?.target?.outerText?.trim()?.length) {
      locationDropClickHandler();
    }
  };
  const switchHandler = (e) => {
    let switchVal = e.target.checked ? 1 : 0;
    setSpecialisedSwitch(switchVal);
    setActionsOnDataToSend(selectedState, selectedCity, switchVal);
  };

  useEffect(() => {
    if (dataToSend?.[vendorId - 1]) {
      let {
        state = "",
        city = "",
        isSpecialised = 0,
      } = dataToSend?.[vendorId - 1];
      setSelectedState(state || "");
      setSelectedCity(city || "");
      setSpecialisedSwitch(isSpecialised || 0);
    }
  }, [dataToSend, vendorId]);

  return (
    <>
      <div className={style["vendor_card_container"]}>
        <div className={style["specialized-css-div"]}>
          <p
            className={style["specialized-css"]}
            style={{ fontSize: "1.2rem" }}
          >
            Specialized Vendor
          </p>
          <CustomSwitch
            checked={specialisedSwitch ? true : false}
            onChange={switchHandler}
          />
        </div>
        <div
          className={style["vendorCard_right-side_contain"]}
          onClick={locationDropClickHandler}
        >
          {selectedState && selectedCity ? (
            <h5 className={style["location-css"]}>
              {`${selectedCity
                .split("")
                .map((item, index) =>
                  index !== 0 ? item.toLowerCase() : item.toUpperCase()
                )
                .join("")}, ${stateShortFormObj[selectedState]}`}
            </h5>
          ) : (
            <p>Location</p>
          )}
          {isLocationSelectOpen ? (
            <KeyboardArrowUpIcon
              sx={{ marginLeft: "1rem", color: "#505050", fontSize: "2rem" }}
            />
          ) : (
            <KeyboardArrowDownIcon
              sx={{ marginLeft: "1rem", color: "#505050", fontSize: "2rem" }}
            />
          )}
        </div>
      </div>

      {isLocationSelectOpen && (
        <div className={style["location-dropdown-main-container"]}>
          <CustomSelect
            onChange={stateChangeHandler}
            searchable
            id="state"
            name="state"
            options={[...dropdownData?.map((obj) => obj?.state)]}
            value={selectedState}
            sx={locationDropdownStyle}
            placeholder="Select State"
            disabled={isReassign && reassignType === "same"}
          />
          <CustomSelect
            disabled={
              (isReassign && reassignType === "same") ||
              selectedState.length === 0
                ? true
                : false
            }
            onChange={selectCityHandler}
            searchable
            id="city"
            name="city"
            options={[
              ...(dropdownData?.find(
                (obj) =>
                  obj?.state?.toLowerCase() == selectedState?.toLowerCase()
              )?.city || []),
            ]}
            value={selectedCity}
            sx={locationDropdownStyle}
            placeholder="Select City / District"
          />
        </div>
      )}
    </>
  );
}

export default VendorLocationCard;
